import React from "react";
import styles from "./ServiceStatus.css";
import messages from "../../locales";
import classNames from "classnames";
import TruckEnable from "../../images/truck_enable.svg";
import TruckDisable from "../../images/truck_disable.svg";
import CheckmarkEnable from "../../images/checkmark_enable.svg";
import CheckmarkDisable from "../../images/checkmark_disable.svg";

interface StatusProps {
  disabled: boolean;
  EnableIcon: any;
  DisableIcon: any;
  text: string;
}

const Status = ({ disabled, DisableIcon, EnableIcon, text }: StatusProps) => (
  <div className={styles.status}>
    <div className={styles.icon}>
      {disabled ? <DisableIcon /> : <EnableIcon />}
    </div>
    <div className={classNames(styles.text, disabled && styles.disabled)}>
      {text}
    </div>
  </div>
);
interface ServiceStatusProps {
  fleetName: string;
  arrived: boolean;
}

export const ServiceStatus = ({ fleetName, arrived }: ServiceStatusProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.fleetName}>{fleetName}</div>
      <div className={styles.containerStatus}>
        <Status
          disabled={arrived}
          EnableIcon={TruckEnable}
          DisableIcon={TruckDisable}
          text={messages.omw}
        />
        <div className={styles.bar} />
        <Status
          disabled={!arrived}
          EnableIcon={CheckmarkEnable}
          DisableIcon={CheckmarkDisable}
          text={messages.finished}
        />
      </div>
    </div>
  );
};
